import Axios from "axios";
import {
    SET_PUR_REQUSITION_LIST,
    UNSET_PUR_REQUSITION_LIST,
    SET_SELECTED_PUR_REQUSITION_LIST,
    UNSET_SELECTED_PUR_REQUSITION_LIST,
    SET_PENDING_PUR_REQUISITION,
    UNSET_PENDING_PUR_REQUISITION,
    SET_ORDERABLE_PUR_REQUSITION_LIST,
    UNSET_ORDERABLE_PUR_REQUSITION_LIST,
    SET_MERGEABLE_PUR_REQUSITION_LIST,
    UNSET_MERGEABLE_PUR_REQUSITION_LIST,
  } from "@/store/mutation-types";
import {
  saveUpdatePurRequisition, 
  getPurRequisitionList, 
  getSelectedPurRequisitionList, 
  getPurRequisitionById as getPurRequisitionByIdApi, 
  getPendingPurRequisition, 
  getPurRequisitionWithApprovalById,
  getOrderablePurchaseRequisitionList,
  getMergeablePurchaseRequisitionList,
} from "@/store/api";
// initial state
const state = {
  getPurRequisitionList: [],
  getSelectedPurRequisitionList: [],
  getPendingPurRequisition: [],
  editingRequisition: null,
  getOrderablePurchaseRequisitionList:[],
  getMergeablePurchaseRequisitionList:[],
};

const getters = {
  getOrderablePurchaseRequisitionList(state){
    return state.getOrderablePurchaseRequisitionList;
  },
  getPurRequisitionList(state) {
    return state.getPurRequisitionList;
  },
  getSelectedPurRequisitionList(state) {
    return state.getSelectedPurRequisitionList;
  },
  getPendingPurRequisition(state) {
    return state.getPendingPurRequisition;
  },
  getMergeablePurchaseRequisitionList(state){
    return state.getMergeablePurchaseRequisitionList;
  },
};

const mutations = {
  [SET_ORDERABLE_PUR_REQUSITION_LIST](state, data) {
    state.getOrderablePurchaseRequisitionList = data;
  },
  [UNSET_ORDERABLE_PUR_REQUSITION_LIST](state) {
    state.getOrderablePurchaseRequisitionList = [];
  },
  [SET_PUR_REQUSITION_LIST](state, data) {
    state.getPurRequisitionList = data;
  },
  [UNSET_PUR_REQUSITION_LIST](state) {
    state.getPurRequisitionList = [];
  },
  [SET_SELECTED_PUR_REQUSITION_LIST](state, data) {
    state.getSelectedPurRequisitionList = data;
  },
  [UNSET_SELECTED_PUR_REQUSITION_LIST](state) {
    state.getSelectedPurRequisitionList = [];
  },
  [SET_PENDING_PUR_REQUISITION](state, data) {
    state.getPendingPurRequisition = data;
  },
  [UNSET_PENDING_PUR_REQUISITION](state) {
    state.getPendingPurRequisition = [];
  },
  setEditingRequisition(state, requisition) {
    state.editingRequisition = requisition;
  },
  [SET_MERGEABLE_PUR_REQUSITION_LIST](state, data) {
    state.getMergeablePurchaseRequisitionList = data;
  },
  [UNSET_MERGEABLE_PUR_REQUSITION_LIST](state) {
    state.getMergeablePurchaseRequisitionList = [];
  },
};

const actions = {
  getOrderablePurchaseRequisitionList({ commit }, params) {
      commit("SET_LOADING", { color: "primary" });
      return new Promise((resolve, reject) => {
          Axios.get(getOrderablePurchaseRequisitionList, { params })
              .then((response) => {
                  commit(SET_ORDERABLE_PUR_REQUSITION_LIST, response.data.data);
                  resolve(response);
              })
              .catch((error) => {
                  commit(UNSET_ORDERABLE_PUR_REQUSITION_LIST);
                  reject(error);
              })
              .finally(() => {
                  commit("UNSET_LOADING");
              });
      });
  },
  getMergeablePurchaseRequisitionList({ commit }, params) {
      commit("SET_LOADING", { color: "primary" });
      return new Promise((resolve, reject) => {
          Axios.get(getMergeablePurchaseRequisitionList, { params })
              .then((response) => {
                  commit(SET_MERGEABLE_PUR_REQUSITION_LIST, response.data.data);
                  resolve(response);
              })
              .catch((error) => {
                  commit(UNSET_MERGEABLE_PUR_REQUSITION_LIST);
                  reject(error);
              })
              .finally(() => {
                  commit("UNSET_LOADING");
              });
      });
  },
  saveUpdatePurRequisition({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePurRequisition, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getPurRequisitionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPurRequisitionList, data)
        .then(function (response) {
          commit('SET_PUR_REQUSITION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PUR_REQUSITION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getSelectedPurRequisitionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSelectedPurRequisitionList, data)
        .then(function (response) {
          commit('SET_SELECTED_PUR_REQUSITION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SELECTED_PUR_REQUSITION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getPurRequisitionById({ commit }, id) {
    const getPurRequisitionById = `${getPurRequisitionByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getPurRequisitionById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");  
        });
    });
  },

  getPendingPurRequisition({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPendingPurRequisition, data)
        .then(function (response) {
          commit('SET_PENDING_PUR_REQUISITION', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PENDING_PUR_REQUISITION')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getPurRequisitionWithApprovalById({ commit }, id) {
    const getPurRequisitionWithApproval= `${getPurRequisitionWithApprovalById}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getPurRequisitionWithApproval)
        .then((response) => {
          resolve(response.data.data);
          commit("UNSET_LOADING");
        })
        .catch((error) => {
          reject(error);
          commit("UNSET_LOADING");
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
